export const relationOptions = [
  { name: 'Keluarga' },
  { name: 'Orang Tua' },
  { name: 'Saudara' },
  { name: 'Suami/Istri' },
  { name: 'Guru' },
  { name: 'Teman' },
];
export const idTypeCats = [
  { name: 'KTP' },
  { name: 'SIM' },
  { name: 'Kartu Pelajar' },
  { name: 'Paspor' },
  { name: 'KITAS' },
  // { name: 'ID Card' },
  // { name: 'Driving License' },
  // { name: 'Student Card' },
  // { name: 'Passport' },
  // { name: 'Limited Stay Permit Card' },
];

export const idTypeCatsDomestic = [
  { name: 'KTP' },
  { name: 'SIM' },
  { name: 'Kartu Pelajar' },
  // { name: 'ID Card' },
  // { name: 'Driving License' },
  // { name: 'Student Card' },
  // { name: 'Passport' },
  // { name: 'Limited Stay Permit Card' },
];
// export const genderRange = [{ name: 'Male' }, { name: 'Female' }];
export const genderRange = [{ name: 'Laki-laki' }, { name: 'Perempuan' }];
export const countryOptions = [
  { name: 'Indonesia', code: 'ID' },
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Aland Islands', code: 'AX' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Iran', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea', code: 'KR' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn Islands', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
  },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZN' },
];
// export const bloodTypeOptions = [
//   { name: 'A+' },
//   { name: 'A-' },
//   { name: 'B+' },
//   { name: 'B-' },
//   { name: 'AB+' },
//   { name: 'AB-' },
//   { name: 'O+' },
//   { name: 'O-' },
//   { name: 'Tidak Tahu!' },
// ];
export const bloodTypeOptions = [
  { name: 'A' },
  { name: 'B' },
  { name: 'AB' },
  { name: 'O' },
  // { name: 'Tidak Tahu!' },
];
export const userTypeOptions = [
  { name: 'Umum' },
  { name: 'Alumni / Mahasiwa(i) FIB' },
  // { name: 'Tidak Tahu!' },
];
export const yearOptions = [
  { name: '1970' },
  { name: '1971' },
  { name: '1972' },
  { name: '1973' },
  { name: '1974' },
  { name: '1975' },
  { name: '1976' },
  { name: '1977' },
  { name: '1978' },
  { name: '1979' },
  { name: '1980' },
  { name: '1981' },
  { name: '1982' },
  { name: '1983' },
  { name: '1984' },
  { name: '1985' },
  { name: '1986' },
  { name: '1987' },
  { name: '1988' },
  { name: '1989' },
  { name: '1990' },
  { name: '1991' },
  { name: '1992' },
  { name: '1993' },
  { name: '1994' },
  { name: '1995' },
  { name: '1996' },
  { name: '1997' },
  { name: '1998' },
  { name: '1999' },
  { name: '2000' },
  { name: '2001' },
  { name: '2002' },
  { name: '2003' },
  { name: '2004' },
  { name: '2005' },
  { name: '2006' },
  { name: '2007' },
  { name: '2008' },
  { name: '2009' },
  { name: '2010' },
  { name: '2011' },
  { name: '2012' },
  { name: '2013' },
  { name: '2014' },
  { name: '2015' },
  { name: '2016' },
  { name: '2017' },
  { name: '2018' },
  { name: '2019' },
  { name: '2020' },
  { name: '2021' },
  { name: '2022' },
  { name: '2023' },
  { name: '2024' },
  { name: '2025' },
  { name: '2026' },
];
export const prodiOptions = [
  { name: 'D3 Sastra Jepang' },
  { name: 'S1 Arkeologi' },
  { name: 'S1 Ilmu Filsafat' },
  { name: 'S1 Ilmu Perpustakaan' },
  { name: 'S1 Ilmu Sejarah' },
  { name: 'S1 Bahasa dan Kebudayaan Korea' },
  { name: 'S1 Sastra Arab' },
  { name: 'S1 Sastra Belanda' },
  { name: 'S1 Sastra Cina' },
  { name: 'S1 Sastra Indonesia' },
  { name: 'S1 Sastra Inggris' },
  { name: 'S1 Sastra Jepang' },
  { name: 'S1 Sastra Jerman' },
  { name: 'S1 Sastra Prancis' },
  { name: 'S1 Sastra Rusia' },
  { name: 'S1 Sastra Daerah untuk Sastra Jawa' },
  { name: 'S2 Arkeologi' },
  { name: 'S2 Asia Timur' },
  { name: 'S2 Asia Tenggara' },
  { name: 'S2 Ilmu Filsafat' },
  { name: 'S2 Ilmu Linguistik' },
  { name: 'S2 Ilmu Perpustakaan' },
  { name: 'S2 Ilmu Sejarah' },
  { name: 'S2 Ilmu Susastra' },
  { name: 'S3 Arkeologi' },
  { name: 'S3 Ilmu Filsafat' },
  { name: 'S3 Ilmu Sejarah' },
  { name: 'S3 Ilmu Susastra' },
  { name: 'S3 Ilmu Linguistik' },
  { name: 'S3 Kajian Informasi' },
];
const sizeOpts = [
  { name: 'XS' }, //0
  { name: 'S' },
  { name: 'M' },
  { name: 'L' },
  { name: 'XL' },
  { name: '2XL' },
  { name: '3XL' },
  { name: '4XL' },
  { name: '5XL' },
  { name: '6XL' },
  { name: '7XL' },
  { name: '8XL' }, //11
];
export const classTypeOptions = [
  { name: 'General' },
  { name: 'Student' },
  { name: 'Internal' },
];

export const parqAnswersOptions = [
  { name: 'Tidak sama sekali' },
  { name: 'Kurang dari 1(satu) minggu' },
  { name: 'Lebih dari 1(satu) minggu' },
  { name: 'Hampir setiap hari' },
];

export const healthAnswerOptions = [{ name: 'Ya' }, { name: 'Tidak' }];
export const redBullParq1 = [{ name: 'Tahu' }, { name: 'Tidak Tahu' }];
export const redBullParq2 = [{ name: 'Sudah' }, { name: 'Belum' }];

export const getInitialParticipantState = (
  user,
  isAllSos,
  kidLimit,
  adultLimit,
  participantLimit,
  sizeKidRange,
  sizeAdultRange,
  sizesInfo,
  eventId,
) => {
  // console.log('size info controller', sizesInfo);
  if (participantLimit > 0)
    return getParticipantStates(
      user,
      isAllSos,
      participantLimit,
      sizeKidRange,
      sizeAdultRange,
      sizesInfo,
      eventId,
    );

  const pesertas = [];

  if (adultLimit > 0) {
    const [start, end] = sizeAdultRange.split(',');
    // console.log(sizeAdultRange);
    // console.log(start);
    // console.log(end);

    for (let i = 0; i < adultLimit; i++) {
      const emergency = {
        emergencyPerson: { value: '', errorMessage: '' },
        emergencyContact: { value: '', errorMessage: '' },
        emergencyRelation: { value: '', errorMessage: '' },
      };

      let sizeRange = sizeOpts.slice(parseInt(start), parseInt(end));

      if (sizesInfo?.length > 0) sizeRange = sizesInfo;

      // console.log('dp controller eventId ', eventId);
      if (parseInt(eventId) === 81)
        sizeRange = [
          { name: 'All Size' }, //0
        ];

      const peserta = {
        name: {
          value: i === 0 && user ? `${user?.firstName} ${user?.lastName}` : '',
          errorMessage: '',
        },
        runningFor: { value: '', errorMessage: '' },
        gender: { value: '', errorMessage: '' },
        nationality: { value: '', errorMessage: '' },
        idType: { value: '', errorMessage: '' },
        idNumber: { value: '', errorMessage: '' },
        birthDate: { value: '', errorMessage: '' },
        bloodType: { value: '', errorMessage: '' },
        classType: { value: '', errorMessage: '' },
        contact: { value: '', errorMessage: '' },
        orgCom: { value: '', errorMessage: '' },
        size: { value: '', errorMessage: '' },
        street: { value: '', errorMessage: '' },
        kelurahan: { value: '', errorMessage: '' },
        kecamatan: { value: '', errorMessage: '' },
        kota: { value: '', errorMessage: '' },
        kodepos: { value: '', errorMessage: '' },
        tindakanoperasi: { value: '', errorMessage: '' },
        npa: { value: '', errorMessage: '' },
        sizeRange,
        type: 'adult',
      };

      pesertas.push(isAllSos === 0 ? peserta : { ...peserta, ...emergency });
    }
  }

  if (kidLimit > 0) {
    const [start, end] = sizeKidRange.split(',');

    let sizeRange = sizeOpts.slice(parseInt(start), parseInt(end));

    if (sizesInfo?.length > 0) sizeRange = sizesInfo;

    if (parseInt(eventId) === 81)
      sizeRange = [
        { name: 'All Size' }, //0
      ];

    for (let i = 0; i < kidLimit; i++) {
      const emergency = {
        emergencyPerson: { value: '', errorMessage: '' },
        emergencyContact: { value: '', errorMessage: '' },
        emergencyRelation: { value: '', errorMessage: '' },
      };
      const peserta = {
        name: { value: '', errorMessage: '' },
        runningFor: { value: '', errorMessage: '' },
        gender: { value: '', errorMessage: '' },
        nationality: { value: '', errorMessage: '' },
        idType: { value: '', errorMessage: '' },
        idNumber: { value: '', errorMessage: '' },
        birthDate: { value: '', errorMessage: '' },
        bloodType: { value: '', errorMessage: '' },
        classType: { value: '', errorMessage: '' },
        contact: { value: '', errorMessage: '' },
        orgCom: { value: '', errorMessage: '' },
        size: { value: '', errorMessage: '' },
        street: { value: '', errorMessage: '' },
        kelurahan: { value: '', errorMessage: '' },
        kecamatan: { value: '', errorMessage: '' },
        kota: { value: '', errorMessage: '' },
        kodepos: { value: '', errorMessage: '' },
        tindakanoperasi: { value: '', errorMessage: '' },
        npa: { value: '', errorMessage: '' },
        sizeRange,
        type: 'kid',
      };

      pesertas.push(isAllSos === 0 ? peserta : { ...peserta, ...emergency });
    }
  }

  return pesertas;
};

const getParticipantStates = (
  user,
  isAllSos,
  limit,
  sizeKidRange,
  sizeAdultRange,
  sizesInfo,
  eventId,
) => {
  const pesertas = [];

  let sizeParticipants = sizeParticipantsOpts(sizeAdultRange, sizeKidRange);

  if (sizesInfo?.length > 0) sizeParticipants = sizesInfo;

  if (parseInt(eventId) === 81)
    sizeParticipants = [
      { name: 'All Size' }, //0
    ];

  // console.log(sizeParticipants);

  for (let i = 0; i < limit; i++) {
    const emergency = {
      emergencyPerson: { value: '', errorMessage: '' },
      emergencyContact: { value: '', errorMessage: '' },
      emergencyRelation: { value: '', errorMessage: '' },
    };

    const peserta = {
      name: {
        value: i === 0 && user ? `${user?.firstName} ${user?.lastName}` : '',
        errorMessage: '',
      },
      runningFor: { value: '', errorMessage: '' },
      gender: { value: '', errorMessage: '' },
      nationality: { value: '', errorMessage: '' },
      idType: { value: '', errorMessage: '' },
      idNumber: { value: '', errorMessage: '' },
      birthDate: { value: '', errorMessage: '' },
      bloodType: { value: '', errorMessage: '' },
      classType: { value: '', errorMessage: '' },
      contact: { value: '', errorMessage: '' },
      orgCom: { value: '', errorMessage: '' },
      size: { value: '', errorMessage: '' },
      street: { value: '', errorMessage: '' },
      kelurahan: { value: '', errorMessage: '' },
      kecamatan: { value: '', errorMessage: '' },
      kota: { value: '', errorMessage: '' },
      kodepos: { value: '', errorMessage: '' },
      tindakanoperasi: { value: '', errorMessage: '' },
      npa: { value: '', errorMessage: '' },
      sizeRange: sizeParticipants,
      type: 'Common',
    };

    pesertas.push(isAllSos === 0 ? peserta : { ...peserta, ...emergency });
  }

  // console.log(pesertas);
  return pesertas;
};

const sizeParticipantsOpts = (adultRange, kidsRange) => {
  const [aStart, aEnd] = adultRange.split(',');
  const [kStart, kEnd] = kidsRange.split(',');

  const kidsOpts = sizeOpts.map((os) => {
    return { name: `Kid - ${os.name}` };
  });

  let aSizes = [];
  let kSizes = [];

  if (aEnd >= 0) aSizes = sizeOpts.slice(parseInt(aStart), parseInt(aEnd));
  if (kEnd >= 0) kSizes = kidsOpts.slice(parseInt(kStart), parseInt(kEnd));

  return aSizes.length > 0 && kSizes.length > 0
    ? [...aSizes, ...kSizes]
    : aSizes.length > 0
      ? aSizes
      : kSizes;
};
